import { useState } from "react";
import { supabase } from "../lib/supabase";
import { Ico } from "./icons";

interface Props {
  onSignIn: (token: string) => void;
}

export function Login({ onSignIn }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { data, error: signInError } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (signInError || !data.session) {
      setError(signInError?.message ?? "Login fehlgeschlagen");
      return;
    }
    onSignIn(data.session.access_token);
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <span className="brand-mark">cf</span>
          <span className="brand-wordmark">Claude<em>Flow</em></span>
        </div>

        <div>
          <h1 className="login-title">Willkommen <em>zurück.</em></h1>
          <p className="login-sub">
            Multi-Agent Workspace für dein Team.<br />
            Auf <span style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: "var(--color-fg)" }}>vps-fra1.claudeflow.dev</span>.
          </p>
        </div>

        <div className="field">
          <label htmlFor="email">E-Mail</label>
          <input
            id="email" type="email" className="input" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="pw">Passwort</label>
          <input
            id="pw" type="password" className="input" required autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {error && (
          <div className="callout" style={{ borderColor: "var(--color-error)", color: "var(--color-error)" }}>
            {error}
          </div>
        )}

        <button className="btn btn-primary" type="submit" disabled={busy}>
          {busy ? "Verbinde…" : "Anmelden"}
          {!busy && <Ico name="arrow-right" size={14} />}
        </button>

        <div className="callout">
          <span className="ico"><Ico name="info" size={14} /></span>
          <div>
            Dein <b style={{ color: "var(--color-fg)" }}>Claude Max Account</b> wird über den Server genutzt — angemeldet via{" "}
            <code>claude auth login</code> auf deinem Linux-User.
          </div>
        </div>

        <div className="login-foot">
          <a href="#">Passwort vergessen?</a>
          <span>Supabase Auth · ClaudeFlow v0.1.0</span>
        </div>
      </form>
    </div>
  );
}
